<div [ngStyle]="contentStyle" class="section h-100 pointer-events-none">
  <form [formGroup]="editAddressForm">
    <div class="text-left mt-3">
      <div>
        <finx-input
          [textInputFontStyle]="textInputFontStyle"
          type="text"
          class="profile-input"
          formControlName="address1"
          [inputStyle]="inputFieldAddressStreetStyle"
          [colorTextAlignStyle]="colorTextAlignStyle"
          [label]="(dataIn?.attri?.widgetProperties?.addressLabel || 'Address') + ' 1'"
          [value]="editAddressForm?.get('address1')?.value"
          (keyup)="valueChanges()"
          (focusEvent)="updateInputFieldStyles($event, 'addressStreet')"
        ></finx-input>
      </div>
    </div>

    <div class="text-left mt-3">
      <div>
        <finx-input
          [textInputFontStyle]="textInputFontStyle"
          type="text"
          class="profile-input"
          formControlName="address2"
          [inputStyle]="inputFieldAddressStreetStyle"
          [colorTextAlignStyle]="colorTextAlignStyle"
          [label]="(dataIn?.attri?.widgetProperties?.addressLabel || 'Address') + ' 2'"
          [value]="editAddressForm?.get('address2')?.value"
          (keyup)="valueChanges()"
          (focusEvent)="updateInputFieldStyles($event, 'addressStreet')"
        ></finx-input>
      </div>
    </div>

    <div class="text-left mt-3">
      <div>
        <finx-input
          [textInputFontStyle]="textInputFontStyle"
          type="text"
          class="profile-input"
          formControlName="address3"
          [inputStyle]="inputFieldAddressStreetStyle"
          [colorTextAlignStyle]="colorTextAlignStyle"
          [label]="(dataIn?.attri?.widgetProperties?.addressLabel || 'Address') + ' 3'"
          [value]="editAddressForm?.get('address3')?.value"
          (keyup)="valueChanges()"
          (focusEvent)="updateInputFieldStyles($event, 'addressStreet')"
        ></finx-input>
      </div>
    </div>

    <div class="text-left mt-3">
      <div>
        <finx-input
          [textInputFontStyle]="textInputFontStyle"
          type="text"
          class="profile-input"
          formControlName="address4"
          [inputStyle]="inputFieldAddressStreetStyle"
          [colorTextAlignStyle]="colorTextAlignStyle"
          [label]="(dataIn?.attri?.widgetProperties?.addressLabel || 'Address') + ' 4'"
          [value]="editAddressForm?.get('address4')?.value"
          (keyup)="valueChanges()"
          (focusEvent)="updateInputFieldStyles($event, 'addressStreet')"
        ></finx-input>
      </div>
    </div>

    <div class="text-left mt-3">
      <div>
        <finx-input
          [textInputFontStyle]="textInputFontStyle"
          type="text"
          class="profile-input"
          formControlName="addressCity"
          [inputStyle]="inputFieldAddressCityStyle"
          [colorTextAlignStyle]="colorTextAlignStyle"
          [label]="dataIn?.attri?.widgetProperties?.cityLabel"
          [value]="editAddressForm?.get('addressCity')?.value"
          (keyup)="valueChanges()"
          (focusEvent)="updateInputFieldStyles($event, 'addressCity')"
        ></finx-input>
      </div>
    </div>
    <div class="text-left mt-3">
      <div>
        <finx-input
          [textInputFontStyle]="textInputFontStyle"
          type="text"
          class="profile-input"
          formControlName="addressState"
          [inputStyle]="inputFieldAddressStateStyle"
          [colorTextAlignStyle]="colorTextAlignStyle"
          [label]="dataIn?.attri?.widgetProperties?.stateRegionLabel"
          [value]="editAddressForm?.get('addressState')?.value"
          (keyup)="valueChanges()"
          (focusEvent)="updateInputFieldStyles($event, 'addressState')"
        ></finx-input>
      </div>
    </div>
    <div class="text-left mt-3">
      <div>
        <finx-input
          [textInputFontStyle]="textInputFontStyle"
          type="text"
          class="profile-input"
          formControlName="addressPostCode"
          [inputStyle]="inputFieldAddressPostCodeStyle"
          [colorTextAlignStyle]="colorTextAlignStyle"
          [label]="dataIn?.attri?.widgetProperties?.zipPostalLabel"
          [value]="editAddressForm?.get('addressPostCode')?.value"
          (keyup)="valueChanges()"
          (focusEvent)="updateInputFieldStyles($event, 'addressPostCode')"
        ></finx-input>
      </div>
    </div>
    <div class="text-left mt-3">
      <div>
        <div class="profile-input mb-2">
          <label [ngStyle]="colorTextAlignStyle">{{ dataIn?.attri?.widgetProperties?.countryLabel }}</label>
        </div>
        <finx-dropdown
          [textInputFontStyle]="textInputFontStyle"
          formControlName="addressCountry"
          label="title"
          appendto="body"
          [options]="countryList"
          [showAccountsListWithFlag]="true"
          [inputStyle]="inputFieldAddressCountryStyle"
          [value]="editAddressForm?.get('addressCountry')?.value"
          (valueChange)="valueChanges()"
          (focusEvent)="updateInputFieldStyles($event, 'addressCountry')"
        ></finx-dropdown>
      </div>
    </div>
  </form>
</div>
